import Button from './button-TEMPLATE_VERSION'

export default Button
